module.exports = __webpack_public_path__ + "img/2_94.12e979e1.png";